function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.672 8.91942C11.728 8.91942 13.248 8.70542 13.248 7.46103C13.256 7.36592 13.248 7.27081 13.224 7.17569L12.6 4.48085C12.456 3.88639 12.328 3.61691 11.272 3.09379C10.456 2.68164 8.68 2 8.152 2C7.664 2 7.52 2.62616 6.936 2.62616C6.376 2.62616 5.96 2.15852 5.432 2.15852C4.928 2.15852 4.6 2.49934 4.344 3.19683C4.344 3.19683 3.64 5.17834 3.544 5.46367C3.536 5.51916 3.528 5.56671 3.528 5.62219C3.528 6.39102 6.584 8.91149 10.672 8.91149V8.91942ZM13.416 7.9683C13.56 8.64993 13.56 8.72127 13.56 8.7926C13.56 9.98151 12.232 10.6235 10.496 10.6235C6.56 10.6235 3.112 8.34082 3.112 6.83487C3.112 6.62087 3.16 6.4148 3.24 6.22457C1.824 6.28798 0 6.54161 0 8.14267C0 10.7741 6.272 14 11.24 14C15.048 14 16 12.2959 16 10.9485C16 9.88639 15.08 8.68164 13.416 7.9683Z",
  fill: "currentColor"
});

function SvgSpy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpy);
export default __webpack_public_path__ + "static/media/spy.e9153680.svg";
export { ForwardRef as ReactComponent };